
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_6rxu0_17",
  "dismiss-button": "awsui_dismiss-button_1i2wg_6rxu0_49",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_6rxu0_90",
  "icon": "awsui_icon_1i2wg_6rxu0_96",
  "icon-inline": "awsui_icon-inline_1i2wg_6rxu0_102",
  "token-normal": "awsui_token-normal_1i2wg_6rxu0_107",
  "token-inline": "awsui_token-inline_1i2wg_6rxu0_114",
  "token-option-inline": "awsui_token-option-inline_1i2wg_6rxu0_140",
  "token-box": "awsui_token-box_1i2wg_6rxu0_144",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_6rxu0_163",
  "token-box-inline": "awsui_token-box-inline_1i2wg_6rxu0_167",
  "disable-padding": "awsui_disable-padding_1i2wg_6rxu0_187",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_6rxu0_194",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_6rxu0_195"
};
  